export default {
  title: 'Vastaanota uutisia ja tarjouksia sähköpostitse',
  form: {
    marketing_subscription: {
      label: 'Saat eksklusiivisia tarjouksia, alennuksia ja päivityksiä suoraan sähköpostiisi',
    },
  },
};
